import { Injectable } from '@nestjs/common';
import { PassportStrategy } from '@nestjs/passport';
import config from 'config';
import { passportJwtSecret } from 'jwks-rsa';
import { ExtractJwt, Strategy } from 'passport-jwt';

import { User } from '../types';

@Injectable()
export class JwtStrategy extends PassportStrategy(Strategy) {
  constructor() {
    super({
      algorithms: ['RS256'],
      audience: `https://${config.get('clerk.domain')}`,
      ignoreExpiration: false,
      ignoreNotBefore: true,
      issuer: `https://${config.get('clerk.domain')}`,
      jwtFromRequest: ExtractJwt.fromAuthHeaderAsBearerToken(),
      secretOrKeyProvider: passportJwtSecret({
        cache: true,
        jwksUri: `https://${config.get('clerk.domain')}/.well-known/jwks.json`,
        jwksRequestsPerMinute: 5,
        rateLimit: true,
      }),
    });
  }

  public validate(profile: any): User {
    return {
      clerkId: profile.sub,
      email: profile[`${config.get('clerk.prefix')}/email`],
      firstName: profile[`${config.get('clerk.prefix')}/first_name`],
      id: profile[`${config.get('clerk.prefix')}/user_metadata`].id,
      lastName: profile[`${config.get('clerk.prefix')}/last_name`],
      organizations: profile[`${config.get('clerk.prefix')}/organizations`],
      sessionId: profile.sid,
    };
  }
}
